import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { PATH } from "../../../router/path";

const EmptyCart = (): ReactElement => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<div className="EmptyCart">
			<span className="EmptyCartInfo">{t("cartPage.emptyCart.info")}</span>
			<span className="EmptyCartInfo2">{t("cartPage.emptyCart.info2")}</span>
			<button
				className="EmptyCartAddItemButton"
				data-testid="empty-cart-add-item-button"
				onClick={() => navigate(PATH.PRODUCT_LIST)}
			>
				{t("cartPage.emptyCart.additem")}
			</button>
		</div>
	);
};

export default EmptyCart;
